/**
 * UI copy shared across features. Feature-specific copy lives in each feature's
 * `constants.ts` (e.g. `AUTH_TEXT`); only strings reused by several features belong here.
 */
export const COMMON_TEXT = {
  brand: {
    appName: 'Compliance Desk',
    firmName: 'SHDA CPA',
    firmLegalName: 'SHDA CPA LLC',
  },
  actions: {
    cancel: 'Cancel',
    clear: 'Clear',
    clearFilters: 'Clear filters',
    close: 'Close',
    columns: 'Columns',
    connect: 'Connect',
    delete: 'Delete',
    disconnect: 'Disconnect',
    edit: 'Edit',
    export: 'Export',
    exportCsv: 'Export CSV',
    remove: 'Remove',
    save: 'Save',
    saveAsDraft: 'Save as draft',
    send: 'Send',
    turnOff: 'Turn off',
    turnOn: 'Turn on',
    undo: 'Undo',
    upload: 'Upload',
    verify: 'Verify',
    view: 'View',
  },
  fields: {
    actions: 'Actions',
    address: 'Address',
    amount: 'Amount',
    assignedTo: 'Assigned to',
    client: 'Client',
    clientCode: 'Client code',
    clientGroup: 'Client group',
    clientName: 'Client name',
    description: 'Description',
    dueDate: 'Due date',
    email: 'Email',
    entityType: 'Entity type',
    firstName: 'First name',
    from: 'From',
    lastName: 'Last name',
    message: 'Message',
    notes: 'Notes',
    password: 'Password',
    period: 'Period',
    service: 'Service',
    status: 'Status',
    subtotal: 'Subtotal',
    to: 'To',
    total: 'Total',
    username: 'Username',
  },
  placeholders: {
    select: '— select —',
    chooseUser: '— Choose a user —',
  },
  toasts: {
    changesSaved: 'Changes saved.',
    noChangesSaved: 'No changes saved',
    nothingToExport: 'Nothing to export',
  },
  cannotBeUndone: 'This cannot be undone.',
} as const;
